import Joi from 'joi'

const PotentialBookingFileValidation = Joi.object({
  potentialBookingFileId: Joi.number().required().empty(0),
  potentialBookingMappingId: Joi.number().required().empty(0),
})

export { PotentialBookingFileValidation }
